import React, { useState } from 'react'
import { option1, showAspectRatioData } from 'config/static-data/editor-modal-data'
import { useMediaQuery } from 'react-responsive'
import PromptSelection from 'components/Modals/EditorModal/Editor/components/PromptSelection'
import { generateFinalPromptStr } from 'utils/formatUtils'

const PromptBuilder = ({ onConfirm }) => {
  const [initialPrompt, setInitialPrompt] = useState('')
  const [selectedParameters, setSelectedParameters] = useState({})
  const [aspectRatio, setAspectRatio] = useState('1:1')
  const [imagesToGenerate, setImagesToGenerate] = useState(2)
  const [showAspectRatio, setShowAspectRatio] = useState(false)

  const isMobile = useMediaQuery({ maxWidth: 600 })

  const handleEnterKey = (e) => {
    e.keyCode === 13 && onConfirm(generateFinalPromptStr(selectedParameters, initialPrompt))
  }

  const handleSelectedParaRemove = (key) => {
    selectedParameters?.[key] &&
      setSelectedParameters((prev) => {
        const newParameters = { ...prev }
        delete newParameters[key]
        return newParameters
      })
  }

  const handleSelectedOptionChange = (parameterType, item) => {
    setSelectedParameters((prev) => ({
      ...prev,
      [parameterType]: prev[parameterType]?.title === item.title ? null : item,
    }))
  }

  return (
    <div className="generate-box-header flex flex-col item-start justify-between gap-1 pt-4 w-full z-10 relative h-[96%] overflow-hidden">
      <div className="flex justify-between w-full rounded-none">
        <div className="flex w-[98%] items-start justify-between gap-4 flex-col md:flex-row">
          <div className="bg-gray-100 w-full md:w-[80%] text-gray-700 font-medium pt-[6px] pb-[5px] px-4 rounded-none transition-all duration-300 ease-in-out">
            <div className="relative flex gap-2 mr-2 bg-gray-100 text-gray-700 font-medium py-1 rounded-none justify-between">
              <span className="text-gray-700 font-black  whitespace-nowrap">Prompt | </span>
              <input
                type="text"
                placeholder="What do you want?"
                className="w-full bg-gray-100 text-gray-700"
                value={initialPrompt}
                onChange={(e) => setInitialPrompt(e.target.value)}
                onKeyDown={handleEnterKey}
              />
            </div>
            <>
              {Object.keys(selectedParameters)?.length > 0 && (
                <div className="flex flex-wrap gap-4 mt-2 py-2 mb-2 ">
                  {Object.keys(selectedParameters)?.map((item, i) => {
                    return (
                      selectedParameters[item] && (
                        <div className="flex items-center gap-2 pr-1 rounded-full overflow-hidden bg-white text-gray-900 border border-gray-300 border-solid">
                          <img
                            src={i < 10 ? `/assets/editor-modal/image${i + 1}.png` : `/assets/editor-modal/image1.png`}
                            className="h-6 w-6"
                            alt="editor"
                          />
                          <span className="font-bold text-xs whitespace-nowrap overflow-hidden text-ellipsis">
                            {selectedParameters[item]?.title}
                          </span>
                          <span
                            className="rounded-full bg-gray-300 p-1 w-5 h-5"
                            onClick={() => handleSelectedParaRemove(item)}
                          >
                            <img src="/assets/common/close.svg" alt="close" />
                          </span>
                        </div>
                      )
                    )
                  })}
                </div>
              )}

              <div className="flex justify-ceter items-center mt-2 gap-4 transition-height duration-150 ease-in">
                <div className="relative">
                  <button
                    className="group/ratio flex h-8 items-center justify-center gap-2 rounded text-neutral-900 "
                    onClick={() => setShowAspectRatio(!showAspectRatio)}
                  >
                    <label className="text-xs font-semibold text-deepblue-900">Ratio </label>
                    <div className="flex h-8 items-center justify-center gap-2 rounded px-2 border border-solid border-neutral-200">
                      <div className="flex items-center">
                        <span className="ml-1 text-xs font-bold ">{aspectRatio}</span>
                      </div>

                      <div className="flex  items-center justify-center ">
                        <img src={'/assets/common/arrow_down.svg'} alt="arrow" />
                      </div>
                    </div>
                  </button>

                  {showAspectRatio && (
                    <div className="z-[90] absolute top-[30px] left-0 shadow-md">
                      <div className="flex flex-col rounded-lg bg-white p-1 shadow-xl dark:bg-gray-700">
                        {showAspectRatioData?.map((item, i) => {
                          return (
                            <span
                              className="flex cursor-pointer items-center gap-1 rounded px-2.5 py-2 text-xs font-semibold text-neutral-900 hover:bg-neutral-50 dark:text-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                              onClick={() => {
                                setAspectRatio(item?.value)
                                setShowAspectRatio(false)
                              }}
                              key={i}
                            >
                              <span className="whitespace-nowrap min-w-[30px]">{item?.value}</span>
                              <span className="whitespace-nowrap">{item?.label}</span>
                            </span>
                          )
                        })}
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <label className="text-xs font-semibold text-deepblue-900">Images</label>

                  <div className="flex h-8 items-center justify-center gap-1 rounded border border-solid border-neutral-200 px-2 text-deepblue-900 ">
                    <button
                      className={`${imagesToGenerate == 1 && 'pointer-events-none opacity-40'}`}
                      onClick={() => setImagesToGenerate(imagesToGenerate - 1)}
                    >
                      -
                    </button>

                    <span className="w-4 text-center text-xs font-bold">{imagesToGenerate}</span>

                    <button
                      onClick={() => setImagesToGenerate(imagesToGenerate + 1)}
                      className={`${imagesToGenerate == 4 && 'pointer-events-none opacity-40'}`}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </>
          </div>
          <button
            className="min-w-full md:min-w-[120px] bg-black text-white font-medium py-2.5 px-4 rounded-none "
            onClick={() => onConfirm(generateFinalPromptStr(selectedParameters, initialPrompt))}
          >
            Confirm
          </button>
        </div>
      </div>
      <div className="hidden justify-between items-center w-full p-4 bg-white rounded-none ">
        <div className="flex items-center">
          <p className="text-gray-700 text-sm">Use the prompts below to customize how you want your output to look.</p>
        </div>
        <div className="flex items-center">
          <label className="inline-flex items-center cursor-pointer">
            <input type="checkbox" className="rounded-none border-gray-300 text-blue-600 shadow-sm " />
            <span className="ml-2 text-gray-700 text-sm">Improve Prompt</span>
          </label>
          <label className="inline-flex items-center cursor-pointer ml-4">
            <input type="checkbox" className="rounded-none border-gray-300 text-blue-600 " />
            <span className="ml-2 text-gray-700 text-sm">Advanced Settings</span>
          </label>
        </div>
      </div>
      <div className="flex justify-center items-center w-full h-[88%] overflow-y-auto">
        <div className="w-[90%] h-full">
          <PromptSelection
            option1={option1}
            isMobile={isMobile}
            handleSelectedOptionChange={handleSelectedOptionChange}
            selectedParameters={selectedParameters}
            containerClassName={'h-full'}
          />
        </div>
      </div>
    </div>
  )
}

export default PromptBuilder
